export default "__VITE_ASSET__CCKEPFHm__"